import React, { useState } from 'react';
import plusButtonStyle from "../../../settings/otherStyles";
import AddIcon from '@material-ui/icons/Add';
import Fab from "@material-ui/core/Fab";

const AddItemButton = ({OnClick, disabled}) => {
  const [internalDisabled, setInternalDisabled] = useState(false);
  
  // Use external disabled prop if provided, otherwise use internal state
  const isDisabled = disabled !== undefined ? disabled : internalDisabled;

  const actionHandler = e => {
    if (disabled === undefined) {
      // Only set internal disabled if no external control
      setInternalDisabled(true);
    }
    OnClick();
  }

  return (
    <Fab
      onClick={actionHandler}
      color="primary"
      aria-label="Add"
      className={plusButtonStyle.fab}
      disabled={isDisabled}
    >
      <AddIcon />
    </Fab>
  );
};

export default AddItemButton;
